import * as Yup from 'yup';
import { FeedbackReasonValues } from '../enums/FeedbackReasonsValues';

const FEEDBACK_TEXT_MAX_LENGTH = 5000;
const EMPTY_FIELD_ERROR_TEXT = 'Required field';
const FEEDBACK_TEXT_TOO_LONG_ERROR_TEXT = `Must be ${FEEDBACK_TEXT_MAX_LENGTH} characters or less`;

const fieldsSchema = {
  feedbackText: Yup.string()
    .max(FEEDBACK_TEXT_MAX_LENGTH, FEEDBACK_TEXT_TOO_LONG_ERROR_TEXT)
    .required(EMPTY_FIELD_ERROR_TEXT),
  feedbackReason: Yup.string().required(EMPTY_FIELD_ERROR_TEXT),
  summary: Yup.string().when('feedbackReason', {
    is: FeedbackReasonValues.Other,
    then: (schema) => schema.required(EMPTY_FIELD_ERROR_TEXT),
    otherwise: (schema) => schema.optional(),
  }),
};

export const validationSchema = Yup.object().shape(fieldsSchema);
